<ng-container *ngIf="images">
  <ng-container *ngFor="let image of images">
    <img class="thumbnail-image" *ngIf="image" [src]="image.icon" [matTooltip]="image.tooltip | translate">
  </ng-container>
</ng-container>